<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-layout row wrap>
                        <v-toolbar flat color="blue-grey" dark>
                            <v-toolbar-title>Tỷ giá - phí</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex lg6 md6 sm12>
                                    <h-currency-input v-model="configuration.Currency" :decimal="0" label="Tỷ giá bán" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg6 md6 sm12>
                                    <h-currency-input v-model="configuration.ExchangeRateIn" :decimal="0" label="Tỷ giá mua" class="input-group--focused"></h-currency-input>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input v-model="configuration.MinFeeBuy" :decimal="0" label="Phí mua tối thiểu" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input v-model="configuration.MinFeePack" :decimal="1" label="Phí đóng gỗ tối thiểu 1 kiện (¥)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12>
                                    <v-text-field type="number" v-model="configuration.OrderCompleteDate" label="Số ngày tự động hoàn thành đơn" class="input-group--focused"></v-text-field>
                                </v-flex>
                                </v-layout>
                            <v-layout row wrap>
                                <v-flex lg6 md6 sm12>
                                    <h-currency-input :decimal="0" v-model="configuration.Density" label="Tỷ trọng cân nặng" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg6 md6 sm12>
                                    <h-currency-input :decimal="0" v-model="configuration.Surcharge" label="Phụ phí" class="input-group--focused"></h-currency-input>
                                </v-flex>
                            </v-layout>
                            <!-- <v-layout row wrap>
                                <v-flex lg12 md12 sm12>
                                    <v-textarea v-model="configuration.ProductTypes" label="Loại hàng" class="input-group--focused"></v-textarea>
                                </v-flex>
                            </v-layout> -->
                        </v-card-text>
                    </v-layout>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-layout row wrap>
                        <v-toolbar flat color="blue-grey" dark>
                            <v-toolbar-title>Thông báo khách hàng</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="showCode = !showCode">
                                <v-icon color="#ffffff">fa fa-code</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                    <!-- <mavon-editor language="en" v-model="configuration.NoteForCustomer" label="Thông báo khách hàng" class="input-group--focused"/> -->
                                    <vue-editor v-if="!showCode" v-model="configuration.NoteForCustomer" label="Thông báo khách hàng" class="input-group--focused"></vue-editor>
                                    <v-textarea v-else v-model="configuration.NoteForCustomer" label="Thông báo khách hàng" class="input-group--focused"></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-layout>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-layout row wrap>
                        <v-toolbar flat color="blue-grey" dark>
                            <v-tooltip bottom color="primary">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-toolbar-title v-bind="attrs"  v-on="on">Tỷ lệ hoa hồng nhân viên <i class="fa fa-question-circle" aria-hidden="true"></i></v-toolbar-title>
                                </template>
                                <span>
                                    <ul>
                                        <li>Khách mới (đăng ký 120 ngày)</li>
                                        <li>Khách cũ (đăng ký 150 ngày)</li>
                                        <li>Khách trung thành (đăng ký 150 ngày)</li>
                                        <li>Doanh thu = tiền mặc cả được</li>
                                        <li>Doanh thu Order = Phí dịch vụ của đơn mua hộ</li>
                                        <li>Doanh thu cước VCQT Order = Phí cân nặng đơn mua hộ</li>
                                        <li>Doanh thu cước VCQT Ký gửi = Phí cân nặng đơn ký gửi</li>
                                        <li>Tính lợi nhuận của Sale = % lợi nhuận vận chuyển.</li>
                                        <li>Tính lợi nhuận cảu CSKH = % lợi nhuận % đặt hàng.</li>
                                        <li>tính lợi nhuận của Đăt hàng = % lợi nhuận % phí đặt + chênh lệch do đàm phán.</li>
                                    </ul>
                                </span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-card-text>
                            <v-expansion-panels v-model="commission_panel" multiple>
                            <v-expansion-panel>
                                <v-expansion-panel-header>Hoa hồng đặt hàng</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-layout row wrap>
                                        <v-flex lg4 md4 sm12>
                                            <h-currency-input :decimal="1" v-model="configuration.RevenueCommissionRate" label="Chênh lệch doanh thu(%)" class="input-group--focused"></h-currency-input>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex lg4 md4 sm12>
                                            <h-currency-input :decimal="1" v-model="configuration.OrderBuyerCommissionNewRate" label="Phí dịch vụ - Khách mới (%)" class="input-group--focused"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg4 md4 sm12>
                                            <h-currency-input :decimal="1" v-model="configuration.OrderBuyerCommissionMidRate" label="Phí dịch vụ - Khách cũ (%)" class="input-group--focused"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg4 md4 sm12>
                                            <h-currency-input :decimal="1" v-model="configuration.OrderBuyerCommissionOldRate" label="Phí dịch vụ - Trung thành (%)" class="input-group--focused"></h-currency-input>
                                        </v-flex>
                                    </v-layout>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel>
                                <v-expansion-panel-header>Hoa hồng CSKH</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-layout row wrap>
                                        <v-flex lg4 md4 sm12>
                                            <h-currency-input :decimal="1" v-model="configuration.OrderCommissionNewRate" label="Phí dịch vụ - Khách mới (%)" class="input-group--focused"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg4 md4 sm12>
                                            <h-currency-input :decimal="1" v-model="configuration.OrderCommissionMidRate" label="Phí dịch vụ - Khách cũ (%)" class="input-group--focused"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg4 md4 sm12>
                                            <h-currency-input :decimal="1" v-model="configuration.OrderCommissionOldRate" label="Phí dịch vụ - Trung thành (%)" class="input-group--focused"></h-currency-input>
                                        </v-flex>
                                    </v-layout>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel>
                                <v-expansion-panel-header>Hoa hồng Sale</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-layout row wrap>
                                        <v-flex lg4 md4 sm12>
                                            <h-currency-input :decimal="1" v-model="configuration.OrderFeeCommissionNewRate" label="Cước vận chuyển đơn Order - Khách mới (%)" class="input-group--focused"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg4 md4 sm12>
                                            <h-currency-input :decimal="1" v-model="configuration.OrderFeeCommissionMidRate" label="Cước vận chuyển đơn Order - Khách cũ (%)" class="input-group--focused"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg4 md4 sm12>
                                            <h-currency-input :decimal="1" v-model="configuration.OrderFeeCommissionOldRate" label="Cước vận chuyển đơn Order - Trung thành (%)" class="input-group--focused"></h-currency-input>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex lg4 md4 sm12>
                                            <h-currency-input :decimal="1" v-model="configuration.DepositFeeCommissionNewRate" label="Cước vận chuyển đơn KG - Khách mới (%)" class="input-group--focused"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg4 md4 sm12>
                                            <h-currency-input :decimal="1" v-model="configuration.DepositFeeCommissionMidRate" label="Cước vận chuyển đơn KG - Khách cũ (%)" class="input-group--focused"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg4 md4 sm12>
                                            <h-currency-input :decimal="1" v-model="configuration.DepositFeeCommissionOldRate" label="Cước vận chuyển đơn KG - Trung thành (%)" class="input-group--focused"></h-currency-input>
                                        </v-flex>
                                    </v-layout>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            </v-expansion-panels>
                        </v-card-text>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import {
    mapState
} from "vuex";
import { VueEditor } from "vue2-editor";
export default {
    components: {
        VueEditor
    },
    data() {
        return {
            showCode: false,
            commission_panel: [0,1,2]
        }
    },
    computed: {
        ...mapState({
            loading: state => state.configuration.loading,
            configuration: state => state.configuration.selected
        })
    },
    methods: {
        refreshData() {
            this.$store.dispatch("configuration/getDetail", 1);
        },
        saveData() {
            this.$store.dispatch("configuration/setDetail", {
                data: this.configuration,
                id: this.configuration.ID
            });
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.configuration.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
